module.exports = __webpack_public_path__ + "img/pop_bg.e0e5c3b3.png";